import { defineMessages } from 'react-intl';

export default defineMessages({
    dob: {
        id: 'Date of birth',
        defaultMessage: 'Date of birth'
    },
    invalidDateError: {
        id: 'Please enter a valid date',
        defaultMessage: 'Please enter a valid date'
    },
    belowLegalAgeError: {
        id: 'You must be 18 or older to apply',
        defaultMessage: 'You must be 18 or older to apply'
    },
    dayPlaceholder: {
        id: 'DD',
        defaultMessage: 'DD'
    },
    monthPlaceholder: {
        id: 'Month',
        defaultMessage: 'Month'
    },
    yearPlaceholder: {
        id: 'YYYY',
        defaultMessage: 'YYYY'
    }
});
